import { combineReducers } from 'redux';

import discardReason from './discardReason';

export default combineReducers({
  discardReason,
});
